import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { FileDragDrop } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';

const fileDropAnimation = css`
  transition: transform 200ms ease-in-out;
  &.file-drop-appear {
    transform: scale(0);
  }
  &.file-drop-appear-active {
    transform: scale(1);
  }
`;

const DragDropPlaceholder = () => {
  const { t } = useTranslation('Files');
  return (
    <Box className="absolute top-0 bottom-0 z-50 flex w-full flex-1 bg-bg-primary py-24 px-12 end-0 start-0">
      <Box className="flex flex-1 flex-col items-center justify-center rounded-8 border border-dashed border-border-dark">
        <CSSTransition appear in classNames="file-drop" timeout={200}>
          <FileDragDrop className={fileDropAnimation} fillColorToken="icon-white" />
        </CSSTransition>
        <Typography className="w-192 text-center" color="text-text-placeholder" variant="heading-s">
          {t('Files:dragAndDropFiles')}
        </Typography>
      </Box>
    </Box>
  );
};

export default DragDropPlaceholder;
